import { useAppDispatch } from "../../../hooks/hooks";
import { useCallback } from "react";
import { callAsync } from "../../../util/sliceUtil";
import { downloadTestResultItemAsync } from "../../../store/dataSearchSlice";
import { useDownloadFile } from "../../../hooks/common/useDownloadFile";
import { useUtil } from "../../../util/hooks/useUtil";
import { TestResultSearchCondition } from "../../../types/dataSearch";

interface ReturnType {
  downloadTestResultItems: (_: TestResultSearchCondition) => void;
}

export function useTestResultItemDownloader(): ReturnType {
  const dispatch = useAppDispatch();
  const { getDownloadExcelFile } = useDownloadFile();
  const { defaultErrorMessage } = useUtil();

  const downloadTestResultItems = useCallback(
    (condition: TestResultSearchCondition) => {
      callAsync(
        dispatch(downloadTestResultItemAsync(condition)).unwrap(),
        (result) => getDownloadExcelFile(result, "test-result-item"),
        () => {
          alert(defaultErrorMessage);
        }
      ).then();
    },
    [defaultErrorMessage, dispatch, getDownloadExcelFile]
  );

  return {
    downloadTestResultItems,
  };
}
